<template>
    <q-submenu :title="title" :titlelink="titlelink" :baseUrl="baseUrl" :buttons="buttons" :submenu="submenu" class="q-sticky"></q-submenu>
</template>
<script>
//wholesale version
import QSubmenu from '@/components/navigation/Submenus/QSubmenu.vue'
export default {
    props: ["hasDemo"],
    data() {
        return {
            title: "My Stats",
            baseUrl: "/my_stats",
            titlelink: [],
            submenu: [{
                label: "Help",
                to: "/page/frequently-asked-questions",
            }],
        }
    },
    computed: {
        buttons: function() {
            if (this.hasRole(['Staff', 'SuperAdmin', 'Exec'])) {
                var r = [];
                if (this.tenantHasFeature('Scorecards.Submitted') || this.tenantHasFeature('Scorecards.Placed')) {
                    r.push({
                        label: "Production",
                        to: "/my_stats/scorecard/new_business",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: "v-monthly-1"
                    });
                }
                if (this.tenantHasFeature('Scorecards.Recruiting')) {
                    r.push({
                        label: "Recruiting",
                        to: "/my_stats/scorecard/recruiting",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: "v-monthly-2"
                    });
                }
                if (this.tenantHasFeature('Leads')) {
                    r.push({
                        label: "Leads",
                        to: "/my_stats/scorecard/leads",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: "v-monthly-3"
                    });
                }
                if (this.tenantHasFeature('Scorecards.Events')) {
                    r.push({
                        label: "Event Stats",
                        to: "/my_stats/scorecard/events",
                        icon: "fas fa-arrow-alt-circle-right",
                    });
                }
                if (this.hasRole(['SuperAdmin'])) {
                    if (this.tenantHasFeature('Stats')) {
                        r.push({
                            label: "HQ Stats",
                            to: "/my_stats/scorecard/hq",
                            icon: "fas fa-arrow-alt-circle-right",
                            id: ""
                        });
                    }
                }
                return r;
            }
            if (this.hasRole(['AgencyOwner'])) {
                var r = [];
                if (this.tenantHasFeature('Scorecards.Submitted') || this.tenantHasFeature('Scorecards.Placed')) {
                    r.push({
                        label: "Production",
                        to: "/my_stats/scorecard/new_business",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: "v-monthly-1"
                    });
                }
                if (this.tenantHasFeature('Scorecards.Recruiting')) {
                    r.push({
                        label: "Recruiting",
                        to: "/my_stats/scorecard/recruiting",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: "v-monthly-2"
                    });
                }
                if (this.tenantHasFeature('Leaderboards')) {
                    r.push({
                        label: "Leaderboards",
                        to: "/my_stats/leaderboards",
                        icon: "fas fa-arrow-alt-circle-right",
                    });
                }
                if (this.tenantHasFeature('Scorecards.Events')) {
                    r.push({
                        label: "Event Stats",
                        to: "/my_stats/scorecard/events",
                        icon: "fas fa-arrow-alt-circle-right",
                    });
                }
                /*
                if (this.tenantHasFeature('Stats')) {
                    r.push({
                        label: "HQ Stats",
                        to: "/my_stats/scorecard/hq",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: ""
                    });
                }*/
                return r;
            } else {
                var r = [];
                if (this.tenantHasFeature('Scorecards.Submitted') || this.tenantHasFeature('Scorecards.Placed')) {
                    r.push({
                        label: "Production",
                        to: "/my_stats/scorecard/new_business",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: "v-monthly-1"
                    });
                }
                if (this.tenantHasFeature('Scorecards.Recruiting')) {
                    r.push({
                        label: "Recruiting",
                        to: "/my_stats/scorecard/recruiting",
                        icon: "fas fa-arrow-alt-circle-right",
                        id: "v-monthly-2"
                    })
                }
                return r;
            }
        },
    },
    components: {
        QSubmenu
    },
    methods: {},
}
</script>
<style>
</style>